module.exports = __webpack_public_path__ + "assets/img/34_772.2d5f0a74.jpg";